import React, { useState } from "react";
import MyContext from "./MyContext";

function MyProvider({ children }) {
  //Authentication
  const [dataFetched, setDataFetched] = useState(false);
  const [getIp, setGetIp] = useState(false);
  const [headers, setHeaders] = useState(null);
  const [idVerification, setIdVerification] = useState(false);
  const [idVerificationRequired, setIdVerificationRequired] = useState(false);
  const [idVerificationFailed, setIdVerificationFailed] = useState(false);
  const [requestAuthentication, setRequestAuthentication] = useState(false);

  //Dev or Production
  const [dev, setDev] = useState(false);

  //Data
  const [data, setData] = useState({
    //Authentication
    otp: "",
    leadId: "",

    //Customer Data
    title: "",
    initials: "",
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    age: "",
    idNumber: "",
    idType: "",
    idCountry: "",
    saCitizen: "",
    occupation: "",
    maritalStatus: "",
    mobile: "",
    workTelNo: "",
    homeTelNo: "",
    altTelNo: "",
    email: "",
    preferredCommunicationType: "",
    insuredDriversLicenceCode: "",
    message: "",
    currencyValue: "",
    currencyValueText: "",

    //Docs
    idDoc: "",
    proofOfAddress: "",
    proofOfIncome: "",

    //Location
    ip: "",
    position: { latitude: null, longitude: null },
    signedLocation: "",
    signedDate: "",

    //Street Address
    addressType: "",
    complex: "",
    streetAddress: "",
    streetAddress2: "",
    suburb: "",
    city: "",
    province: "",
    postalCode: "",
    country: "",
    physicalPostalSame: "No",

    //Postal
    postalComplex: "",
    postalAddress: "",
    postalAddress2: "",
    postalSuburb: "",
    postalCity: "",
    postalProvince: "",
    postalPostalCode: "",

    //Terms and Conditions
    acceptTermsAndConditions: "No",
    termsAndConditions:
      "I hereby declare that all information submitted by me in this form is true and correct.",

    //Insurance Data
    typeOfPolicy: "",
    currentlyInsured: "",
    insurerName: "",
    insurerDuration: "",
    insuranceAmount: "",
    insuranceUninterruptedPast36Months: "",
    insuranceClaimsLast12Months: "",
    insuranceClaimsLast24Months: "",
    insuranceClaimsLast36Months: "",
    carHireRequired: "",
    carHireType: "",
    carHirePremium: "",
    product: "",

    //Insured Vehicle Data
    vehicleYear: "",
    vehicleAge: "",
    vehicleMake: "",
    vehicleModel: "",
    vehicleMMCode: "",
    vehicleVinNo: "",
    vehicleEngineNo: "",
    vehicleRegNo: "",
    vehicleValue: 0,
    vehicleEstimatedValue: "",
    vehicleUse: "",
    vehicleDriveToWorkPerWeek: "",
    vehicleType: "",
    vehicleEngineCapacity: "",
    vehicleAntiTheftInstalled: "",
    vehicleAntiTheftDetails: "",
    vehicleModifications: "",
    vehicleModificationsDetails: "",
    vehicleImmobiliser: "",
    vehicleRegisteredCode3: "",
    insuranceSub: "",
    insuranceClaimSub20: "",
    insuranceClaimSub40: "",
    insuranceClaimSub60: "",
    insuranceClaimSub80: "",
    insuranceClaimSub100: "",
    insuranceClaimTotal20: "",
    insuranceClaimTotal40: "",
    insuranceClaimTotal60: "",
    insuranceClaimTotal80: "",
    insuranceClaimTotal100: "",

    //Insured Vehicle Risk Address
    riskAddressSame: "",
    riskAddressType: "",
    riskComplex: "",
    riskStreetAddress: "",
    riskSuburb: "",
    riskCity: "",
    riskProvince: "",
    riskPostalCode: "",

    //Insured Vehicle Day Address
    dayRiskAddressSame: "",
    dayAddressType: "",
    dayAddressSecure: "",
    dayComplex: "",
    dayStreetAddress: "",
    daySuburb: "",
    dayCity: "",
    dayProvince: "",
    dayPostalCode: "",

    //Insured Vehicle Night Address
    nightRiskAddressSame: "",
    nightAddressType: "",
    nightAddressSecure: "",
    nightComplex: "",
    nightStreetAddress: "",
    nightSuburb: "",
    nightCity: "",
    nightProvince: "",
    nightPostalCode: "",

    //Insured Vehicle Finance Data
    isVehicleFinanced: "",
    financeCompany: "",
    financeAgreement: "",
    financeAccountNo: "",
    financeBranch: "",
    financeOutstanding: "",
    creditShortfallExtension: "",

    //Insured Vehicle Regular Driver
    regularDriverSame: "",
    regularDriverTitle: "",
    regularDriverFirstName: "",
    regularDriverLastName: "",
    regularDriverIdType: "",
    regularDriverId: "",
    regularDriverOccupation: "",
    regularDriverGender: "",
    regularDriverDob: "",
    regularDriverAge: "",
    regularDriverMaritalStatus: "",
    regularDriverDriversLicenceCode: "",
    regularDriverMobile: "",
    regularDriverWorkTelNo: "",
    regularDriverAltTelNo: "",
    regularDriverEmail: "",

    //Registered Owner
    registeredOwnerSame: "",
    registeredOwnerTitle: "",
    registeredOwnerFirstName: "",
    registeredOwnerLastName: "",
    registeredOwnerIdType: "",
    registeredOwnerId: "",
    registeredOwnerOccupation: "",
    registeredOwnerGender: "",
    registeredOwnerDob: "",
    registeredOwnerAge: "",
    registeredOwnerMaritalStatus: "",
    registeredOwnerDriversLicenceCode: "",
    registeredOwnerMobile: "",
    registeredOwnerWorkTelNo: "",
    registeredOwnerAltTelNo: "",
    registeredOwnerEmail: "",
  });

  //Data Updated
  const [dataUpdated, setDataUpdated] = useState(false);

  const [pdfDocData, setPdfDocData] = useState({
    pdfName: "",
    pdfBase64: null,
  });

  const [idDocData, setIdDocData] = useState({
    name: "",
    base64: null,
  });

  const [proofOfAddressData, setProofOfAddressData] = useState({
    name: "",
    base64: null,
  });

  const [proofOfIncomeData, setProofOfIncomeData] = useState({
    name: "",
    base64: null,
  });

  const [bankStatementData, setBankStatementData] = useState({
    name: "",
    base64: null,
  });

  const [docsSubmitted, setDocsSubmitted] = useState(false);
  const [docsSent, setDocsSent] = useState(false);
  const [docsError, setDocsError] = useState(false);
  const [docsResponse, setDocsResponse] = useState(false);

  //Leads Errors
  const [acceptTermsError, setAcceptTermsError] = useState("");
  const [acceptOneVapTermsError, setAcceptOneVapTermsError] = useState("");
  const [ageError, setAgeError] = useState("");
  const [altNumberError, setAltNumberError] = useState("");
  const [consentBureauInformationError, setConsentBureauInformationError] =
    useState("");
  const [consentFraudIdentityCheckError, setConsentFraudIdentityCheckError] =
    useState("");
  const [contactNumberError, setContactNumberError] = useState("");
  const [formError, setFormError] = useState("");
  const [homeNumberError, setHomeNumberError] = useState("");
  const [idNumberError, setIdNumberError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [postalCodeError, setPostalCodeError] = useState("");
  const [postalPostalCodeError, setPostalPostalCodeError] = useState("");
  const [signatureError, setSignatureError] = useState("");
  const [underAdministrativeOrderError, setUnderAdministrativeOrderError] =
    useState("");
  const [underDebtReviewError, setUnderDebtReviewError] = useState("");
  const [underSequestrationError, setUnderSequestrationError] = useState("");
  const [vehicleYearError, setVehicleYearError] = useState("");
  const [witnessContactNumberError, setWitnessContactNumberError] =
    useState("");
  const [workNumberError, setWorkNumberError] = useState("");

  //Insurance Errors
  const [addressSameError, setAddressSameError] = useState("");
  const [addressSecureError, setAddressSecureError] = useState("");
  const [antiTheftInstalledError, setAntiTheftInstalledError] = useState("");
  const [code3Error, setCode3Error] = useState("");
  const [immobiliserError, setImmobiliserError] = useState("");
  const [modificationsError, setModificationsError] = useState("");
  const [selectError, setSelectError] = useState("");
  const [vehiclesError, setVehiclesError] = useState("");

  //Laminin
  const [lamininSubmitted, setLamininSubmitted] = useState(false);
  const [lamininSent, setLamininSent] = useState(false);
  const [lamininError, setLamininError] = useState(false);
  const [lamininResponse, setLamininResponse] = useState({});

  //Lead Forms
  const [addressDataCaptured, setAddressDataCaptured] = useState(false);
  const [customerDataCaptured, setCustomerDataCaptured] = useState(false);
  const [declarationDataCaptured, setDeclarationDataCaptured] = useState(false);
  const [docsDataCaptured, setDocsDataCaptured] = useState(false);

  //Insurance Forms
  const [captureVehicle, setCaptureVehicle] = useState(false);
  const [dayAddressDataCaptured, setDayAddressDataCaptured] = useState(false);
  const [financeDataCaptured, setFinanceDataCaptured] = useState(false);
  const [insuranceDataCaptured, setInsuranceDataCaptured] = useState(false);
  const [insuredDataCaptured, setInsuredDataCaptured] = useState(false);
  const [nightAddressDataCaptured, setNightAddressDataCaptured] =
    useState(false);
  const [quoteDataCaptured, setQuoteDataCaptured] = useState(false);
  const [registeredOwnerDataCaptured, setRegisteredOwnerDataCaptured] =
    useState(false);
  const [regularDriverDataCaptured, setRegularDriverDataCaptured] =
    useState(false);
  const [riskAddressDataCaptured, setRiskAddressDataCaptured] = useState(false);
  const [vehicleDataCaptured, setVehicleDataCaptured] = useState(false);
  const [vehiclesDataCaptured, setVehiclesDataCaptured] = useState(false);
  const [vehicles, setVehicles] = useState([]);

  return (
    <MyContext.Provider
      value={{
        //Authentication
        dataFetched,
        setDataFetched,
        getIp,
        setGetIp,
        headers,
        setHeaders,
        idVerification,
        setIdVerification,
        idVerificationRequired,
        setIdVerificationRequired,
        idVerificationFailed,
        setIdVerificationFailed,
        requestAuthentication,
        setRequestAuthentication,

        //Dev or Production
        dev,
        setDev,

        //Data
        data,
        setData,

        //Data Updated
        dataUpdated,
        setDataUpdated,

        //Docs
        // docsData,
        // setDocsData,
        pdfDocData,
        setPdfDocData,
        idDocData,
        setIdDocData,
        proofOfAddressData,
        setProofOfAddressData,
        proofOfIncomeData,
        setProofOfIncomeData,
        bankStatementData,
        setBankStatementData,
        docsSubmitted,
        setDocsSubmitted,
        docsSent,
        setDocsSent,
        docsError,
        setDocsError,
        docsResponse,
        setDocsResponse,

        //Lead Errors
        acceptTermsError,
        setAcceptTermsError,
        acceptOneVapTermsError,
        setAcceptOneVapTermsError,
        ageError,
        setAgeError,
        altNumberError,
        setAltNumberError,
        consentBureauInformationError,
        setConsentBureauInformationError,
        consentFraudIdentityCheckError,
        setConsentFraudIdentityCheckError,
        contactNumberError,
        setContactNumberError,
        formError,
        setFormError,
        homeNumberError,
        setHomeNumberError,
        idNumberError,
        setIdNumberError,
        mobileError,
        setMobileError,
        postalCodeError,
        setPostalCodeError,
        postalPostalCodeError,
        setPostalPostalCodeError,
        signatureError,
        setSignatureError,
        underAdministrativeOrderError,
        setUnderAdministrativeOrderError,
        underDebtReviewError,
        setUnderDebtReviewError,
        underSequestrationError,
        setUnderSequestrationError,
        vehicleYearError,
        setVehicleYearError,
        witnessContactNumberError,
        setWitnessContactNumberError,
        workNumberError,
        setWorkNumberError,

        //Insurance Errors
        addressSameError,
        setAddressSameError,
        addressSecureError,
        setAddressSecureError,
        antiTheftInstalledError,
        setAntiTheftInstalledError,
        code3Error,
        setCode3Error,
        immobiliserError,
        setImmobiliserError,
        modificationsError,
        setModificationsError,
        selectError,
        setSelectError,
        vehiclesError,
        setVehiclesError,

        //Laminin
        lamininSubmitted,
        setLamininSubmitted,
        lamininSent,
        setLamininSent,
        lamininError,
        setLamininError,
        lamininResponse,
        setLamininResponse,

        //Lead Forms
        addressDataCaptured,
        setAddressDataCaptured,
        customerDataCaptured,
        setCustomerDataCaptured,
        docsDataCaptured,
        setDocsDataCaptured,
        declarationDataCaptured,
        setDeclarationDataCaptured,

        //Insurance Forms
        captureVehicle,
        setCaptureVehicle,
        dayAddressDataCaptured,
        setDayAddressDataCaptured,
        financeDataCaptured,
        setFinanceDataCaptured,
        insuranceDataCaptured,
        setInsuranceDataCaptured,
        insuredDataCaptured,
        setInsuredDataCaptured,
        nightAddressDataCaptured,
        setNightAddressDataCaptured,
        quoteDataCaptured,
        setQuoteDataCaptured,
        registeredOwnerDataCaptured,
        setRegisteredOwnerDataCaptured,
        regularDriverDataCaptured,
        setRegularDriverDataCaptured,
        riskAddressDataCaptured,
        setRiskAddressDataCaptured,
        vehicleDataCaptured,
        setVehicleDataCaptured,
        vehiclesDataCaptured,
        setVehiclesDataCaptured,
        vehicles,
        setVehicles,
      }}
    >
      {children}
    </MyContext.Provider>
  );
}

export default MyProvider;
